import { useLayoutEffect } from "react"
import { useRouter } from "next/navigation"

import { logout } from "@/actions/auth"
import { store } from "@/lib/store"

const useLatestBuild = (): void => {
  const router = useRouter()
  useLayoutEffect(() => {
    const versionBuildTime = window._phenoDevOptions?.buildTime ?? process.env.NEXT_PUBLIC_BUILD_TIME
    const localBuildTime = localStorage.getItem("buildTime")
    if (!versionBuildTime) {
      return
    }
    if (!localBuildTime) {
      console.info(`first build: ${versionBuildTime}`)
      localStorage.setItem("buildTime", versionBuildTime)
      return
    }
    if (localBuildTime === versionBuildTime) {
      return
    }
    console.info(`new build - local: ${localBuildTime} new: ${versionBuildTime}`)
    store.dispatch(logout())
    localStorage.clear()
    localStorage.setItem("buildTime", versionBuildTime)
    router.refresh()
  }, [router])
}

export default useLatestBuild
